// Mock data for PRESTIGE LPG Kehakliinik clone

export const siteConfig = {
  brand: { name: 'PRESTIGE LPG', subtitle: 'BEAUTY & WELLNESS' },
  contact: {
    phone: '+372 588 80329',
    email: 'kaunisminaou@gmail.com',
    address: 'Hommiku tänav 1, Pärnu, Pärnumaa',
  },
  heroImage: 'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/sqxzlr2k_att.8Zc65C_UdEBRo4EEO4ySl6o9RdfMl5YJ6hSL4eLLIP0.jpeg',
  heroBackground: 'https://images.unsplash.com/photo-1690049098415-29f96fca22c0?auto=format&fit=crop&w=2600&q=90',
  bookingUrl: 'https://prestige-lpg-kehakliinik.salon.life/prestige-lpg-kehakliinik/?fbclid=IwVERDUAS3TlFleHRuA2FlbQIxMABzcnRjBmFwcF9pZAo2NjI4NTY4Mzc5AAEeQFVw3cdOIOUxvCG_NrKZsusKZf-HCA73O6tS5Xq5UlccvNw2UHz5oThRRCk_aem_SU8f0kQGGoK_Dbt4KTVmJQ',
  socials: [
    {
      key: 'instagram',
      label: '@prestigeparnu',
      url: 'https://www.instagram.com/prestigeparnu?stkn=b3M3eGh6NnpkOHhn',
    },
    {
      key: 'facebook',
      label: 'Prestige Beauty & Wellness',
      url: 'https://www.facebook.com/share/18ML6rVKzF/?mibextid=wwXIfr',
    },
  ],
  copyright: '© 2026 PRESTIGE Beauty & Wellness. Kõik õigused reserveeritud.',
};

export const navigation = [
  { label: 'Avaleht', href: '/' },
  { label: 'Teenused', href: '/teenused' },
  { label: 'Hinnakiri', href: '/hinnakiri' },
  { label: 'Meist', href: '/meist' },
  { label: 'Galerii', href: '/galerii' },
  { label: 'Kontakt', href: '/kontakt' },
];

export const heroFeatures = [
  { key: 'tipptehnoloogia', icon: 'diamond', label: 'TIPPTEHNOLOOGIA' },
  { key: 'individuaalne', icon: 'user', label: 'INDIVIDUAALNE LÄHENEMINE' },
  { key: 'tulemused', icon: 'lotus', label: 'NÄHTAVAD TULEMUSED' },
  { key: 'heaolu', icon: 'heart', label: 'SINU HEAOLU ON MEIE PRIORITEET' },
];

export const services = [
  {
    id: 'lpg-alliance-cellu-m6-kehahooldused',
    title: 'LPG KEHA',
    short: 'Keha vormimine, tselluliidi vähendamine, lümfisüsteemi toetamine kaasaegse LPG tehnoloogia abil.',
    image: 'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/wcu5lb7w_IMG_6060.jpeg',
    tagline: 'Professionaalne lahendus',
    tagDesc:
      'Kasutatav tippkliinikutes ja luksuslikes spaades üle maailma. See on parim valik teie keha vormimiseks ja hooldamiseks.',
    richContent: {
      heading: 'LPG Alliance kehahooldused – loomulik tee saledama ja toonuses kehani',
      subheading:
        'Tõhus kehavormimine ilma kirurgilise sekkumiseta – nii naistele kui ka meestele.',
      intro: [
        'LPG Alliance on maailmas tunnustatud prantsuse tehnoloogia, mida on arendatud üle 35 aasta. Algselt taastusravis kasutatud endermoloogia on tänaseks kujunenud üheks hinnatuimaks mitteinvasiivseks kehahoolduseks, mis aitab vähendada tselluliiti, kujundada kehakontuure, parandada naha kvaliteeti ning toetada lümfi- ja vereringet.',
        'Iga hooldus kohandatakse individuaalselt vastavalt kliendi eesmärkidele ja kehaseisundile. Enne kuuri alustamist toimub konsultatsioon, mille käigus valitakse sobiv raviplaan.',
      ],
      sections: [
        {
          title: 'Lipomassaaž – kehakontuuride kujundamine',
          blocks: [
            { type: 'p', text: 'LPG Alliance lipomassaaž aitab vähendada lokaalseid rasvaladestusi piirkondades, mis ei allu alati dieedile ega treeningule.' },
            { type: 'label', text: 'Hoolduse eelised:' },
            { type: 'ul', items: [
              'vähendab lokaalseid rasvapadjandeid;',
              'silub ja vähendab tselluliiti;',
              'pinguldab ning toniseerib nahka;',
              'parandab naha elastsust;',
              'toetab loomulikku rasvaainevahetust.',
            ]},
            { type: 'p', text: 'LPG Alliance stimuleerib mehaaniliselt nahaaluseid kudesid ja rasvarakke, aktiveerides keha loomulikke protsesse. Samal ajal ergutatakse kollageeni, elastiini ja hüaluroonhappe tootmist, mille tulemusena muutub nahk siledamaks, tugevamaks ja elastsemaks.' },
            { type: 'p', text: 'Hooldus sobib eriti hästi kõhu, puusade, reite, tuharate, talje ja käsivarte vormimiseks.' },
            { type: 'p', text: 'Protseduuri kestus: 30–60 minutit.' },
          ],
        },
        {
          title: 'Lümfi- ja vaakumhooldus',
          blocks: [
            { type: 'p', text: 'LPG Alliance aitab parandada vere- ja lümfiringet ning toetab organismi loomulikku jääkainete eemaldamist.' },
            { type: 'label', text: 'Hooldus võib aidata:' },
            { type: 'ul', items: [
              'vähendada turseid;',
              'leevendada raskeid ja väsinud jalgu;',
              'parandada naha toonust;',
              'lõõgastada lihaseid;',
              'toetada taastumist pärast operatsioone või vigastusi;',
              'pehmendada arme ja fibroosi.',
            ]},
            { type: 'p', text: 'Regulaarsete hooldustega paraneb kudede ainevahetus ning keha tunneb end kergemana ja energilisemana.' },
          ],
        },
        {
          title: 'Tselluliidihooldus',
          blocks: [
            { type: 'p', text: 'Tselluliit tekib rasvarakkude, vedeliku ja sidekoe muutuste koosmõjul ning võib esineda igas vanuses ja kehakaalus inimestel.' },
            { type: 'p', text: 'LPG Alliance stimuleerib sügavamaid nahakihte, parandab mikrovereringet ja lümfiringet ning aitab muuta naha siledamaks ja ühtlasemaks.' },
            { type: 'label', text: 'Regulaarse kuuri tulemusena:' },
            { type: 'ul', items: [
              'väheneb tselluliidi nähtavus;',
              'paraneb naha elastsus ja toonus;',
              'aktiveerub ainevahetus;',
              'väheneb vedelikupeetus kudedes;',
              'keha kontuurid muutuvad selgemaks.',
            ]},
          ],
        },
        {
          title: 'Soovitatav ravikuur',
          blocks: [
            { type: 'p', text: 'Esimesed muutused võivad olla märgatavad juba pärast esimest hooldust, kuid parimate ja püsivamate tulemuste saavutamiseks soovitame 10–15 protseduurist koosnevat kuuri 1–2 korda nädalas. Seejärel aitab tulemust säilitada regulaarne hooldus vastavalt spetsialisti soovitusele.' },
            { type: 'p', text: 'Parima tulemuse saavutamiseks soovitame ühendada LPG Alliance hooldused tasakaalustatud toitumise, piisava vee tarbimise ja regulaarse liikumisega.' },
          ],
        },
        {
          title: 'Protseduuri kestus',
          blocks: [
            { type: 'p', text: 'Üks LPG Alliance kehahooldus kestab 30–60 minutit ning viiakse läbi spetsiaalses LPG kostüümis, mis tagab hügieenilise, mugava ja maksimaalselt tõhusa hoolduse.' },
          ],
        },
      ],
    },
  },
  {
    id: 'lpg-naomassaaz',
    title: 'LPG NÄGU',
    short: 'Kaasaegne LPG Alliance Cellu M6 näomassaaž naha elastsuse ja toonuse parandamiseks.',
    image: 'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/90dijp0n_IMG_6059.jpeg',
    intro:
      'LPG Alliance Cellu M6 näohooldus on spetsiaalne näoterapeutiline protseduur, mis kasutab kaasaegset mehaanilist stimulatsioonitehnoloogiat, et parandada näonaha kvaliteeti, elastsust ja sära.',
    goals: [
      'Naha elastsuse ja toonuse parandamine',
      'Miimikajoonte ja kortsude vähendamine',
      'Naha sära taastamine ja näokontuuride korrigeerimine',
      'Mikrovereringe stimuleerimine ja rakkude uuenemine',
    ],
    procedure:
      'LPG-näomassaaž on täiesti mitteinvasiivne ja lõõgastav protseduur, mis stimuleerib mikrovereringet ning parandab kudede hapnikuga varustust. Protseduur on valutu ja sobib kõikidele nahatüüpidele. Seansid kestavad tavaliselt 45–60 minutit.',
    suitedFor:
      'Ideaalne neile, kes soovivad parandada naha kvaliteeti, vähendada kortse ja miimikajooni, tõsta naha elastsust ning saavutada noorema ja värskema välimuse.',
    course:
      'Parimad tulemused saavutatakse tavaliselt 8–10 seansiga. Protseduure soovitatakse teha 1–2 korda nädalas.',
    tagline: 'Naha uuenemine ja regeneratsioon',
    tagDesc:
      'Kaasaegne ja tõhus lahendus näonaha noorendamiseks, elujõu taastamiseks ja näokontuuride parandamiseks.',
  },
  {
    id: 'kavitatsiooniprotseduurid',
    title: 'KAVITATSIOON',
    short: 'Ultrahelikavitatsiooni abil keha vormimine ja rasvaladestuste vähendamine.',
    image: 'https://customer-assets.emergentagent.com/job_intelligent-shtern-10/artifacts/4dcrg996_A5190891-262E-427B-BA83-C6F8768DCF74.webp',
    tagline: 'Mitteinvasiivne',
    tagDesc: 'Turvaline ja tõhus meetod lokaalse rasva vähendamiseks.',
    richContent: {
      heading: 'Kavitatsioon – tõhus kehavormiv hooldus',
      intro: [
        'Kavitatsioon on mitteinvasiivne ultrahelitehnoloogial põhinev kehahooldus, mis aitab vähendada lokaalseid rasvaladestusi ja kujundada kehakontuure. Protseduur ei vaja sisselõikeid, taastumisaega ega anesteesiat ning on mugav ja valutu.',
        'Kõige sagedamini tehakse kavitatsiooni kõhule, reitele, puusadele ja käsivartele, kuid protseduuri saab kasutada ka seljal, õlgadel ning teistel piirkondadel, kus soovitakse vähendada rasvakudet.',
      ],
      sections: [
        {
          title: 'Kuidas kavitatsioon toimib?',
          blocks: [
            { type: 'p', text: 'Protseduuri käigus kasutatakse madalsageduslikku ultraheli, mis mõjutab rasvarakke. Ultrahelilained lõhustavad rasvarakkude membraane, mille tulemusel vabanevad rasvad eemaldab organism loomulike ainevahetus- ja lümfiprotsesside kaudu. Ümbritsevad koed, veresooned ja närvid jäävad seejuures kahjustamata.' },
          ],
        },
        {
          title: 'Võimalikud tulemused',
          blocks: [
            { type: 'ul', items: [
              'Väheneb rasvkude töödeldud piirkonnas.',
              'Kehakontuur muutub saledamaks ja ühtlasemaks.',
              'Väheneb ümbermõõt ning tervislike eluviiside korral võib alaneda ka kehakaal.',
            ]},
            { type: 'p', text: 'Tulemus sõltub iga inimese ainevahetusest, eluviisidest ja lähteolukorrast.' },
          ],
        },
        {
          title: 'Kellele sobib?',
          blocks: [
            { type: 'p', text: 'Kavitatsioon sobib inimestele, kes soovivad vähendada lokaalseid rasvaladestusi ja täiustada kehakontuure. Enne hooldusega alustamist hindab spetsialist, kas protseduur on kliendile sobiv.' },
          ],
        },
        {
          title: 'Vastunäidustused',
          blocks: [
            { type: 'p', text: 'Protseduuri ei tehta järgmistel juhtudel:' },
            { type: 'ul', items: [
              'rasedus ja imetamine;',
              'südamestimulaator või rasked südamehaigused;',
              'vere hüübimishäired;',
              'rasked vereringehaigused;',
              'põletikud, haavad või nahainfektsioonid töödeldavas piirkonnas;',
              'muud terviseseisundid, mille puhul ultraheliravi ei ole soovitatav.',
            ]},
          ],
        },
        {
          title: 'Soovitatav ravikuur',
          blocks: [
            { type: 'p', text: 'Esimesi muutusi võib märgata juba pärast esimest protseduuri, kuid parima tulemuse saavutamiseks soovitame 5–10 hooldusest koosnevat kuuri. Hooldusi tehakse tavaliselt kaks korda nädalas ning seansside vahele peaks jääma vähemalt 1–2 päeva. Tulemuse säilitamiseks võib 4–6 kuu möödudes teha hooldusprotseduure vastavalt vajadusele.' },
          ],
        },
        {
          title: 'Tulemuse toetamine',
          blocks: [
            { type: 'p', text: 'Kavitatsiooni mõju aitab võimendada lümfiringet aktiveeriv hooldus, näiteks pressoteraapia, LPG Alliance või infrapunamatt, mis toetavad ainevahetust ja jääkainete loomulikku väljutamist.' },
            { type: 'p', text: 'Enne ja pärast protseduuri soovitame süüa kergelt ning juua rohkelt vett. Ka järgnevatel päevadel on oluline tarbida vähemalt 1,5–2 liitrit vett päevas. Tasakaalustatud toitumine ja regulaarne liikumine aitavad saavutada paremaid ning püsivamaid tulemusi.' },
          ],
        },
        {
          title: 'Protseduuri kestus',
          blocks: [
            { type: 'p', text: 'Ühe kavitatsiooniseansi kestus on umbes 30–60 minutit. Hooldus tehakse kliendi aluspesus või salongi poolt pakutavas ühekordses pesus. Arvestada tuleks ka lühikese ajaga riietumiseks enne ja pärast protseduuri.' },
          ],
        },
      ],
    },
  },
  {
    id: 'klassikaline-massaaz',
    title: 'MASSAAŽ',
    short: 'Lõõgastav massaaž lihaspingete leevendamiseks ja heaolu paranemiseks.',
    image: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_intelligent-shtern-10/artifacts/belztgeq_massaas%20pilt.jpg',
    intro:
      'Klassikaline massaaž on lõõgastav ja tervendav kogemus, mis aitab vabaneda lihaspingest, parandada vereringet ning vähendada stressi.',
    goals: [
      'Lihaspingete ja valude vähendamine',
      'Vereringe ja lümfitoksu parandamine',
      'Keha ja meelte lõdvestamine',
      'Üldine relaksatsioon ja stressist vabanemine',
    ],
    procedure:
      'Meie spetsialistid kasutavad klassikalisi massaažitehnikaid. Massaaž toimub rahuliku tempoga, hubases keskkonnas. Seansid kestavad tavaliselt 30–90 minutit vastavalt valikule.',
    suitedFor:
      'Klassikaline massaaž sobib kõigile, kes soovivad lõõgastuda, vähendada lihaspingeid ja parandada üldist heaolu. Eriti soovitatav on see istuva tööviisiga inimestele või neile, kes puutuvad kokku regulaarse füüsilise koormusega.',
    course:
      'Optimaalsete tulemuste saavutamiseks on soovitatav käia kord 1–4 nädala jooksul. Protseduuride sagedus sõltub individuaalsetest vajadustest ja eesmärkidest.',
    tagline: 'Professionaalne ja lõõgastav',
    tagDesc: 'Lõõgastus ja tervendus ühes seansis.',
  },
  {
    id: 'inframatt',
    title: 'INFRAMATT',
    short: 'Lõõgastav infrapunasoojuse hooldus lihaste taastumiseks, vereringe toetamiseks ja kogu keha heaoluks.',
    image: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_intelligent-shtern-10/artifacts/7zpx9796_IMG_6874.jpeg',
    tagline: 'Lõõgastav soojushooldus',
    tagDesc: 'Mõnus infrapunasoojus, mis toetab lihaste taastumist ja loomulikku heaolu.',
    richContent: {
      heading: 'Inframatt – lõõgastav infrapunasoojuse hooldus kogu kehale',
      intro: [
        'Inframatt on lõõgastav infrapunasoojuse hooldus, mis soojendab keha ühtlaselt ning pakub mõnusat saunalaadset soojustunnet. Protseduur aitab kehal lõõgastuda, toetab taastumist ja sobib suurepäraselt pärast füüsilist koormust või lihtsalt heaolu parandamiseks.',
        'Inframatti saab nautida iseseisva hooldusena või lisada LPG kehahooldusele veelgi terviklikuma spaakogemuse jaoks.',
      ],
      sections: [
        {
          title: 'Kuidas inframatt toimib?',
          blocks: [
            { type: 'p', text: 'Inframatt kasutab infrapunasoojust, mis soojendab keha sügavamaid kihte õrnalt ja ühtlaselt. Soojus aitab lõõgastada lihaseid, toetab vereringet ning loob kehale rahuliku ja taastava lõõgastuse.' },
            { type: 'p', text: 'Protseduuri ajal ei teki põletavat tunnet, keha soojeneb järk-järgult ning hooldus on enamiku klientide jaoks väga meeldiv.' },
          ],
        },
        {
          title: 'Võimalikud tulemused',
          blocks: [
            { type: 'ul', items: [
              'Aitab lõõgastada pinges ja väsinud lihaseid.',
              'Võib vähendada lihaste jäikustunnet.',
              'Toetab vereringet ja keha loomulikku taastumist.',
              'Pakub mõnusat soojust ja lõõgastust kogu kehale.',
              'Sobib suurepäraselt heaoluhooldusena pärast pikka tööpäeva või trenni.',
            ]},
          ],
        },
        {
          title: 'Kellele sobib?',
          blocks: [
            { type: 'p', text: 'Inframatt sobib inimestele, kes soovivad lõõgastuda, taastuda pärast füüsilist koormust või täiendada oma kehahoolduse kogemust mõnusa infrapunasoojusega.' },
          ],
        },
        {
          title: 'Vastunäidustused',
          blocks: [
            { type: 'label', text: 'Protseduuri ei soovitata järgmistel juhtudel:' },
            { type: 'ul', items: [
              'rasedus;',
              'palavik või ägedad põletikulised haigused;',
              'rasked südame- või vereringehaigused;',
              'aktiivsed nahapõletikud töödeldavas piirkonnas;',
              'muud terviseseisundid, mille puhul infrapunasoojus ei ole soovitatav.',
            ]},
            { type: 'p', text: 'Tugevate tursete, veeniprobleemide, operatsioonijärgse seisundi või Medical LPG kuuri puhul hindab spetsialist inframati sobivust individuaalselt.' },
          ],
        },
        {
          title: 'Soovitatav ravikuur',
          blocks: [
            { type: 'p', text: 'Inframatti võib kasutada vastavalt vajadusele – iseseisva hooldusena või regulaarselt koos teiste kehahooldustega. See sobib eriti hästi LPG kehahoolduse lõpetuseks, et muuta kogu protseduur veelgi lõõgastavamaks.' },
          ],
        },
        {
          title: 'Tulemuse toetamine',
          blocks: [
            { type: 'p', text: 'Pärast hooldust soovitame juua piisavalt vett, et toetada organismi loomulikke protsesse ning hoida keha hästi niisutatuna.' },
          ],
        },
        {
          title: 'Protseduuri kestus',
          blocks: [
            { type: 'p', text: 'Ühe inframati seansi kestus on umbes 30–45 minutit. Protseduuri ajal saab klient mugavalt lõõgastuda ning nautida rahulikku spaakeskkonda.' },
          ],
        },
      ],
    },
  },
  {
    id: 'rf-lifting',
    title: 'RF LIFTING',
    short: 'Naha pinguldamine, elastsuse parandamine ja kehakontuuride täiustamine kaasaegse raadiosagedustehnoloogia abil.',
    image: 'https://customer-assets-m6fa6gv7.emergentagent.net/job_intelligent-shtern-10/artifacts/ss2ea5m0_rf%20pilt.jpg',
    tagline: 'Naha pinguldamine',
    tagDesc: 'Mitteinvasiivne hooldus naha elastsuse ja kehakontuuride toetamiseks.',
    richContent: {
      heading: 'RF kehahooldus – naha pinguldamine ja kehakontuuride täiustamine',
      intro: [
        'RF kehahooldus ehk raadiosagedushooldus on mitteinvasiivne kehahooldus, mis kasutab raadiosageduslikku energiat naha pinguldamiseks ja selle loomulike uuenemisprotsesside toetamiseks. Protseduur on valutu, ei vaja taastumisaega ega kirurgilist sekkumist ning sobib neile, kes soovivad parandada naha toonust ja elastsust.',
        'Kõige sagedamini tehakse RF kehahooldust kõhule, reitele, tuharatele, käsivartele ja puusadele, kuid protseduuri saab kasutada ka teistel kehapiirkondadel, kus nahk on kaotanud oma pinguldatuse.',
      ],
      sections: [
        {
          title: 'Kuidas RF kehahooldus toimib?',
          blocks: [
            { type: 'p', text: 'Protseduuri käigus soojendatakse naha sügavamaid kihte raadiosagedusliku energiaga. Kontrollitud soojus stimuleerib kollageeni ja elastiini tootmist – need on valgud, mis aitavad hoida naha pingul, elastse ja siledana.' },
            { type: 'p', text: 'Soojendav toime toetab ka vereringet ja naha loomulikku ainevahetust, mille tulemusel võib nahk muutuda tugevamaks ja ühtlasemaks.' },
          ],
        },
        {
          title: 'Võimalikud tulemused',
          blocks: [
            { type: 'ul', items: [
              'Nahk muutub pinguldatumaks ja elastsemaks.',
              'Paraneb naha tekstuur ja toon.',
              'Kehakontuurid muutuvad visuaalselt ühtlasemaks.',
              'Võib aidata vähendada naha lõtvust pärast kaalulangust või sünnitust.',
            ]},
            { type: 'p', text: 'Tulemused kujunevad järk-järgult ning sõltuvad naha seisukorrast, vanusest ja eluviisidest.' },
          ],
        },
        {
          title: 'Kellele sobib?',
          blocks: [
            { type: 'p', text: 'RF kehahooldus sobib inimestele, kes soovivad parandada naha elastsust, vähendada lõtvunud naha nähtavust ning toetada kehakontuuride kujundamist. Enne hooldust hindab spetsialist, kas protseduur on kliendile sobiv.' },
          ],
        },
        {
          title: 'Vastunäidustused',
          blocks: [
            { type: 'label', text: 'Protseduuri ei tehta järgmistel juhtudel:' },
            { type: 'ul', items: [
              'rasedus ja imetamine;',
              'südamestimulaator või muud elektroonilised implantaadid;',
              'aktiivsed põletikud või nahainfektsioonid töödeldavas piirkonnas;',
              'pahaloomulised kasvajad;',
              'rasked südame- või vereringehaigused;',
              'muud terviseseisundid, mille puhul raadiosagedushooldus ei ole soovitatav.',
            ]},
          ],
        },
        {
          title: 'Soovitatav ravikuur',
          blocks: [
            { type: 'p', text: 'Esimesi muutusi võib märgata juba pärast esimest hooldust, kuid parima tulemuse saavutamiseks soovitame 5–10 protseduurist koosnevat kuuri. Hooldusi tehakse tavaliselt 1–2 korda nädalas, sõltuvalt naha seisukorrast ja soovitud tulemusest.' },
            { type: 'p', text: 'Tulemuse säilitamiseks soovitame hooldusprotseduure teha vastavalt spetsialisti soovitusele.' },
          ],
        },
        {
          title: 'Tulemuse toetamine',
          blocks: [
            { type: 'p', text: 'RF kehahoolduse mõju aitab toetada piisav vee tarbimine, tasakaalustatud toitumine ja regulaarne liikumine. Vajadusel saab RF kehahooldust kombineerida LPG Alliance\u2019i või kavitatsiooniga, et luua personaalselt sobiv kehahoolduse kuur.' },
          ],
        },
        {
          title: 'Protseduuri kestus',
          blocks: [
            { type: 'p', text: 'Ühe RF kehahoolduse seansi kestus on umbes 30-60 minutit.' },
          ],
        },
      ],
    },
  },
];

export const trustPoints = [
  {
    title: 'Prantsuse tipptasemel tehnoloogia',
    description:
      'Maailmas tunnustatud LPG Alliance tehnoloogia kvaliteetseteks ja tõhusateks hooldusteks.',
  },
  {
    title: 'Rahvusvaheliselt koolitatud spetsialistid',
    description:
      'Professionaalne hoolitsus, mis põhineb teadmistele, kogemusele ja pidevale arengule.',
  },
  {
    title: 'Individuaalne lähenemine',
    description: 'Iga hooldus kohandatakse vastavalt Sinu soovidele ja eesmärkidele.',
  },
  {
    title: 'Loomulikud ja nähtavad tulemused',
    description: 'Tervem, toonuses nahk ja parem enesetunne.',
  },
];

export const priceList = [
  {
    category: 'LPG massaaž kehale',
    items: [
      { name: 'LPG massaaž 1. proovikord (keha)', price: '45€', duration: '35 min' },
      { name: 'LPG massaaž kehale 1 seanss', price: '50€', duration: '60 min' },
      { name: 'LPG massaaž kehale 5 seanssi', price: '230€', duration: '60 min' },
      { name: 'LPG massaaž kehale 10 seanssi', price: '450€', duration: '60 min' },
      { name: 'Meeste LPG proovikord', price: '50€', duration: '45 min' },
      { name: 'Meeste LPG protseduur', price: '50€', duration: '60 min' },
    ],
  },
  {
    category: 'Kavitatsioon',
    items: [
      { name: 'Kavitatsioon 1. proovikord', price: '45€', duration: '35 min' },
      { name: 'Kavitatsioon', price: '45€', duration: '60 min' },
      { name: '5x Pakett – Kavitatsioon', price: '250€', duration: '60 min' },
      { name: '10x Pakett – Kavitatsioon', price: '350€', duration: '60 min' },
    ],
  },
  {
    category: 'Kavitatsioon + LPG',
    items: [
      { name: 'Kavitatsioon + LPG proovikord', price: '89€', duration: '75 min' },
      { name: '1x Kavitatsioon + LPG', price: '89€', duration: '75 min' },
      { name: '5x Kavitatsioon + LPG', price: '500€', duration: '75 min' },
      { name: '10x Kavitatsioon + LPG', price: '780€', duration: '75 min' },
    ],
  },
  {
    category: 'LPG näohooldused',
    items: [
      { name: 'LPG näohooldus + Germaine de Capuccini – Tõeline ilukombo proovikord (nägu)', price: '50€', duration: '75 min' },
      { name: 'LPG näohooldus + Germaine de Capuccini – Tõeline ilukombo kael ja dekoltee', price: '35€', duration: '45 min' },
      { name: 'LPG näohooldus + Germaine de Capuccini – Tõeline ilukombo 1 seanss', price: '60€', duration: '75 min' },
      { name: 'LPG näohooldus + Germaine de Capuccini – Tõeline ilukombo 5 seanssi', price: '260€', duration: '75 min' },
      { name: 'LPG näohooldus + Germaine de Capuccini – Tõeline ilukombo 10 seanssi', price: '400€', duration: '75 min' },
    ],
  },
  {
    category: 'RF kehalifting',
    items: [
      { name: 'RF kehalifting 1. proovikord', price: '45€', duration: '35 min' },
      { name: 'RF kehalifting', price: '50€', duration: '60 min' },
      { name: 'Kavitatsioon + RF', price: '60€', duration: '60 min' },
    ],
  },
  {
    category: 'WOW Shape kehamähis',
    items: [
      { name: 'WOW Shape kehamähis', price: '80€', duration: '60 min' },
      { name: 'WOW Shape kehamähis 5x pakett', price: '300€', duration: '60 min' },
      { name: 'WOW Shape kehamähis 10x pakett', price: '600€', duration: '60 min' },
      { name: 'LPG massaaž + Wow Shape kehamähis', price: '100€', duration: '105 min' },
      { name: 'LPG massaaž 10 korda + Wow Shape kehamähis 5 korda pakett', price: '600€', duration: '105 min' },
    ],
  },
  {
    category: 'Massaažid',
    items: [
      { name: 'Kombineeritud massaaž kuppudega (Gerli)', price: '40–55€', duration: '60 min' },
      { name: 'Kombineeritud massaaž kuppudega (Gerli)', price: '60–70€', duration: '90 min' },
      { name: 'Klassikaline massaaž', price: '25–35€', duration: '30 min' },
      { name: 'Klassikaline massaaž', price: '30–40€', duration: '45 min' },
      { name: 'Klassikaline massaaž', price: '35–45€', duration: '60 min' },
      { name: 'Klassikaline massaaž', price: '50–65€', duration: '90 min' },
      { name: 'Selja, õlavöötme, peamassaaž', price: '25–35€', duration: '30 min' },
      { name: 'Selja, õlavöötme, käte ja pea massaaž', price: '30–40€', duration: '45 min' },
      { name: 'Õliga lõõgastav üldmassaaž', price: '35–45€', duration: '60 min' },
      { name: 'Lõõgastav aroomimassaaž', price: '40–45€', duration: '60 min' },
      { name: 'Värskendav jalamassaaž', price: '30–35€', duration: '30 min' },
    ],
  },
  {
    category: 'Tasuta konsultatsioon',
    items: [
      { name: 'Konsultatsioon', price: 'TASUTA', duration: '15 min' },
    ],
  },
];

export const timeSlots = [
  '09:00', '10:00', '11:00', '12:00', '13:00',
  '14:00', '15:00', '16:00', '17:00', '18:00',
];
